import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import colors from "/styles/colors";
import { StyledSwitchingWordsComponent } from "./switching-words-component.scss";
class SwitchingWordsComponent extends PureComponent {
    componentDidMount() {
        const { animationInterval } = this.props;
        if (animationInterval) {
            this._changeActiveIndexInterval = setInterval(this.changeActiveIndex, animationInterval);
        }
        this._isMounted = true;
    }
    componentWillUnmount() {
        clearInterval(this._changeActiveIndexInterval);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.activeIndex !== prevState.propActiveIndex) {
            return {
                activeIndex: nextProps.activeIndex,
                prevActiveIndex: prevState.activeIndex,
                propActiveIndex: nextProps.activeIndex
            };
        }
        return null;
    }
    changeActiveIndex() {
        const { words } = this.props;
        const { activeIndex } = this.state;
        const nextActiveIndex = (activeIndex + 1) % words.length;
        this.setState({
            activeIndex: nextActiveIndex,
            prevActiveIndex: activeIndex
        });
    }
    shouldAnimateWordEntrance(wordIndex) {
        const { skipAnimation } = this.props;
        if (skipAnimation) return false;
        const { activeIndex } = this.state;
        return activeIndex === wordIndex && this._isMounted;
    }
    shouldAnimateWordExit(wordIndex) {
        const { skipAnimation } = this.props;
        if (skipAnimation) return false;
        const { activeIndex, prevActiveIndex } = this.state;
        return prevActiveIndex === wordIndex && this._isMounted;
    }
    renderWord(word, index) {
        const { activeIndex, prevActiveIndex } = this.state;
        const { text, color } = word;
        const style = {
            color: colors[color]
        };
        const active = activeIndex === index;
        const animateEntrance = this.shouldAnimateWordEntrance(index);
        const animateExit = this.shouldAnimateWordExit(index);
        return /*#__PURE__*/ _jsx("div", {
            className: classnames("switching-word-item-wrapper", {
                active,
                "animate-entrance": animateEntrance,
                "animate-exit": animateExit
            }),
            style: style,
            children: text
        }, index);
    }
    render() {
        const { words, wordWidth } = this.props;
        return /*#__PURE__*/ _jsx(StyledSwitchingWordsComponent, {
            className: "switching-words-component",
            style: {
                width: wordWidth
            },
            children: words.map(this.renderWord)
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeIndex: props.activeIndex,
            prevActiveIndex: null,
            propActiveIndex: props.activeIndex
        };
        this._isMounted = false;
        this.changeActiveIndex = this.changeActiveIndex.bind(this);
        this.renderWord = this.renderWord.bind(this);
        this._changeActiveIndexInterval = null;
    }
}
export { SwitchingWordsComponent as default };
SwitchingWordsComponent.defaultProps = {
    words: [],
    activeIndex: 0,
    skipAnimation: false
};
